import React, {Component} from 'react';
import {
  View,
  Text,
  ActivityIndicator,
  Alert,
  Dimensions,
  BackHandler,
  TouchableOpacity,
  ScrollView
} from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import i18n from 'i18n-js';
import {connect} from 'react-redux';
import {GetItem, SetItem} from '../../actions/updateAsyncAction';
import CommonStyles from '../../style/commonStyles';
import ArrowKeyNavigationHandler from '../../commons/arrowKeyNavigationHandler';
import TabKeyNavigationHandler from '../../commons/tabKeyNavigationHandler';

import {
  GetOrderDetail,
  UpdateOrderQuantity,
  RemoveOrderItems,
  UpdateOrderInfo,
  UpdateOrderStatus,
  CartedOrdersPreview,
  activityTextFile,
  emailCustomer,
  recordException,
  clearException,
  RemoveBox,
  AddBox,
  AddItemBox,
  PrintSlip
} from '../../actions/orderActions';
import {OrderBackButtonClick} from '../../actions/headerActions';
import ItemsDetail from './items_detail';
import NotesDetail from './notes_detail';
import {SubmitLog} from '../../actions/saveLogAction';
import ActivitiesExceptionDetail from './activities_exception_detail';
import MultiBoxDetail from './multi_box_detail';
import InformationDetail from './information_detail';
import styles from '../../style/orderdetail';
import {LinearGradient} from 'expo-linear-gradient';
import UnsavedChangesBar from '../../commons/unsavedChanges/UnsavedChangesBar';
import UnsavedChangesPrompt from '../../commons/unsavedChanges/UnsavedChangesPrompt';
import UnsavedChangesController from '../../commons/unsavedChanges/UnsavedChangesController';
import {serializeForComparison} from '../../commons/unsavedChanges/compareValues';
import {GetBothSettings} from '../../actions/userAction';
import InterNetChecks from '../internateConnectionCheck';
import InerternetConnectionAlert from '../internetConnectionAlert';
import PackingCamDetail from '../scanpack/packing_cam_detail';
import ShippingLabel from './shipping_label';
import {executeIfUpdationAllowed} from '../../helpers/getLighterColor';
import PopupAlert from '../../commons/popupAlert';
import CartRemovalConfirmModal, {buildCartRemovalMessage, getPreviewFailureMessage} from './cartRemovalPrompt';
import {StatusChangeOutcomeModal, getStatusChangeOutcome, getStatusFailureMessage} from './statusChangeModals';

let saveData = false;
let productID = 0;
let removeOrder = true;
let updateOrder = true;
let fetchData = true;
let isfromEmailPopup = false;
let updateOrderSuccessNew = true;
const windowHeight = Dimensions.get('window').height;

class OrderDetail extends Component {
  constructor(props) {
    super(props);
    this.unsavedController = new UnsavedChangesController({
      isDirty: () => this.state.hasUnsavedChanges,
      onBlocked: () => this.setState({unsavedPromptVisible: true}),
      getNavigation: () => this.props.navigation
    });
    this.alertBox = null;
    this.state = {
      data: {
        filter: 'awaiting',
        order: 'DESC',
        limit: '1',
        offset: '0'
      },
      dataList: {
        filter: 'awaiting',
        order: 'DESC',
        limit: '1',
        offset: '0',
        app: 'app'
      },
      visible: false,
      loadingMessage: 'Loading...',
      itemActive: true,
      notesActive: false,
      informationActive: false,
      activitiesActive: false,
      multiBoxActive: false,
      packingCamActive: false,
      shippingLabelActive: false,
      items: [],
      removeIds: [],
      order: [],
      windowWidth: 0,
      hasUnsavedChanges: false,
      unsavedPromptVisible: false,
      popInternet: true,
      productPermissionPopup: false,
      isFromProductPage: false,
      currentOrderIndex: props.route?.params?.currentOrderIndex || 0,
      ordersList: props.route?.params?.ordersList || []
    };
    window.addEventListener('resize', this.update);
  }

  getOrderStatus = ()=>{
    return this.state?.order?.basicinfo?.status;
  }

  componentDidMount() {
    const sI = setInterval(this.test, 2000);
    this.props.GetBothSettings();
    const id = this.props.route?.params?.item?.id || null;
    this.setState({id});

    if (id) {
      this.apiCall(id);
      this.multipleTime();
    }

    this.backHandler = BackHandler.addEventListener(
      'hardwareBackPress',
      this.backAction
    );
    this.update();
    this.unsavedController.attach();
    if (this.props?.route?.params?.userData?.role?.add_edit_order_items === false) {
      this.setState({productPermissionPopup: true});
    }
  }
  update = () => {
    this.setState({
      windowWidth: window.innerWidth
    });
  };

  backAction = () => {
    Alert.alert('Hold on!', 'Are you sure you want to go back?', [
      {
        text: 'Cancel',
        onPress: () => null,
        style: 'cancel'
      },
      {text: 'YES', onPress: () => this.handleSaveAndClose()}
    ]);
    return true;
  };

  multipleTime = async () => {
    let getItem = await AsyncStorage.getItem('logsArray');
    let convert = getItem && JSON.parse(getItem);
   this.state.popInternet && this.props.SubmitLog(convert);
  };
  removeBox = id => {
    let data = {
      id
    };
    this.props.RemoveBox(data);
  };

  addBox = item => {
    this.props.AddBox(item);
  };

  addItemBox = ID => {
    this.props.AddItemBox(ID);
  };
  printSlip = item => {
    this.props.PrintSlip(item);
  };

  componentDidUpdate(prevProps, prevState) {
    const {
      orderDetail,
      removeOrderItems,
      updateOrderSuccess,
      route,
      navigation
    } = this.props;

    const hasLocalEdits = this.computeUnsavedChanges();
    const adoptOrder = orderDetail !== this.state.order && !hasLocalEdits;
    if (adoptOrder) {
      this.snapshotSavedOrder(orderDetail);
      this.setState({order: orderDetail, visible: false, hasUnsavedChanges: false}, () => {
        if (route?.params?.from === 'ScanPackItem' || route.params.isFromGrid) {
          this.changeState('shippingLabelActive');
        }
      });
    } else if (hasLocalEdits !== this.state.hasUnsavedChanges) {
      this.setState({hasUnsavedChanges: hasLocalEdits});
    }

    if (prevState && prevState.hasUnsavedChanges !== this.state.hasUnsavedChanges) {
      this.unsavedController.sync();
    }

    if (removeOrder && removeOrderItems) {
      this.apiCall(this.state.id);
      removeOrder = false;
    }

    if (updateOrder && route?.params?.from === 'UpdateOrder') {
      const id = route.params.data;
      this.apiCall(id);
      updateOrder = false;
      navigation.navigate('OrderDetail', {data: null, from: null});
    }

    if (
      updateOrderSuccessNew &&
      updateOrderSuccess?.scan_pack_data &&
      updateOrderSuccess?.scan_pack_data[0] &&
      updateOrderSuccess?.scan_pack_data[0].scan_hash.data
    ) {
      const closingAfterSave = this._closingAfterSave;
      this._closingAfterSave = false;

      this.setState({visible: false});
      updateOrderSuccessNew = false;

      if (isfromEmailPopup) {
        isfromEmailPopup = false;
      } else if (!closingAfterSave) {
        if (!this.unsavedController.hasPendingNavigation()) {
          this.apiCall(this.state.id);
        }
      } else {
        this.unsavedController.allowNextNavigation();

        if (route.params.page === 'OrderSearch') {
          this.goBackPage();
        } else if (route.params.page === 'AllOrders') {
          navigation.navigate('AllOrders', {data: {from: 'orderDetailPage'}});
        } else if (prevProps?.route?.params?.page === 'ScanToCartScanning') {
          navigation.navigate('ScanToCart', {
            data: {
              from: 'orderDetailPage',
              order: route.params?.callOrder
            }
          });
        } else {
          navigation.navigate('ScanPackItem', {
            data: {
              from: 'orderDetailPage',
              order: route.params?.callOrder
            }
          });
        }
      }
    }
  }
  apiCall = id => {
    if (id !== null) {
      const detail = {
        id,
        orderDetail: this.state.data
      };
      this.props.GetOrderDetail(detail);
    }
  };

  redirect(item) {
    this.props.navigation.navigate('ProductDetail', {
      data: item,
      token: this.state.token,
      url: this.state.url
    });
  }

  changeState = state => {
    const newState = {
      itemActive: false,
      notesActive: false,
      informationActive: false,
      activitiesActive: false,
      multiBoxActive: false,
      packingCamActive: false,
      shippingLabelActive: false
    };

    switch (state) {
      case 'itemActive':
        newState.itemActive = true;
        break;
      case 'notesActive':
        newState.notesActive = true;
        break;
      case 'informationActive':
        newState.informationActive = true;
        break;
      case 'activitiesActive':
        newState.activitiesActive = true;
        break;
      case 'multiBoxActive':
        newState.multiBoxActive = true;
        break;
      case 'packingCamActive':
        newState.packingCamActive = true;
        break;
      case 'shippingLabelActive':
        newState.shippingLabelActive = true;
        break;
      default:
        break;
    }
    this.setState(newState);
  };

  updateQuantity = async item => {
    if (!item) return false;
    const result = await this.props.UpdateOrderQuantity({
      orderitem: item.iteminfo.id,
      qty: parseInt(item.iteminfo.qty, 10),
      on_ex: 'on GPX'
    });
    if (!result?.ok) {
      const message = Array.isArray(result?.error) && result.error.length > 0
        ? result.error.join(' ')
        : i18n.t('order.quantityUpdateFailed');
      this.alertBox(message, false);
      return false;
    }
    return true;
  };

  addOrderItem() {
    executeIfUpdationAllowed(this.getOrderStatus(),() => {
      this.changeState('itemActive');
      updateOrder = true;
    }, this.alertBox);
  }

  removeOrderItem(ids) {
    executeIfUpdationAllowed(this.getOrderStatus(), () => {
      const {removeIds} = this.state;
      const index = removeIds.indexOf(ids.iteminfo.id);
      if (index !== -1) {
        removeIds.splice(index, 1);
      } else {
        removeIds.push(ids.iteminfo.id);
      }
      this.setState({removeIds: [...removeIds]});
    }, this.alertBox);
  }

  removeItems = async () => {
    executeIfUpdationAllowed(this.getOrderStatus(), async () => {
      const {removeIds} = this.state;
      if (removeIds && removeIds.length > 0) {
        const data = {
          orderitem: removeIds,
          on_ex: 'on GPX'
        };
        await this.props.RemoveOrderItems(data);
        removeOrder = true;
      }
    }, this.alertBox);
  };
  goToProductDetail = id => {
    let page = 'OrderDetail';
    const orderItems = this.state.order?.items || [];
    const productsList = orderItems
      .map(item => ({id: item.productinfo?.id}))
      .filter(item => item.id);
    const currentProductIndex = productsList.findIndex(item => item.id === id);
    this.props.navigation.navigate('ProductDetail', {
      productInfo: id,
      userData: this.props.route.params.userInfo,
      page: page,
      orderID: this.state.order?.basicinfo?.id,
      orderStatus: this.state.order?.basicinfo?.status,
      productsList,
      currentProductIndex: currentProductIndex >= 0 ? currentProductIndex : 0,
      onComeBack: () => {
        this.apiCall(this.state.order?.basicinfo?.id);
        this.props.navigation.goBack()
      }
    });
  };

  handleBasicInfo(name, value) {
    const order = this.state.order;
    if (!order || !order.basicinfo) return;

    this.setState({
      order: {...order, basicinfo: {...order.basicinfo, [name]: value}}
    });
  }

  updateOrderStatus = value => {
    executeIfUpdationAllowed(this.getOrderStatus(), () => this.checkCartThenChangeStatus(value), this.alertBox);
  };

  checkCartThenChangeStatus = async value => {
    const data = {
      filter: 'all',
      inverted: false,
      limit: 20,
      offset: 0,
      order: 'DESC',
      orderArray: [{id: this.state.order?.basicinfo?.id}],
      product_search_toggle: 'true',
      reallocate_inventory: false,
      search: '',
      select_all: false,
      sort: '',
      status: value
    };
    if (this.statusChangeBusy) return;
    this.statusChangeBusy = true;
    try {
      const preview = await this.props.CartedOrdersPreview(data);
      if (!preview.ok) {
        this.alertBox(getPreviewFailureMessage(preview), false);
        return;
      }
      if (Number(preview.data?.carted_count) > 0) {
        this.setState({
          cartRemovalPrompt: {
            data,
            message: buildCartRemovalMessage(preview.data, true)
          }
        });
        return;
      }
      await this.sendStatusChange(data);
    } finally {
      this.statusChangeBusy = false;
    }
  };

  sendStatusChange = async data => {
    const basicInfo = this.state?.order?.basicinfo;
    const result = await this.props.UpdateOrderStatus(data);
    if (!result.ok) {
      this.alertBox(getStatusFailureMessage(result), false);
    }
    const outcome = getStatusChangeOutcome(result);
    if (result.ok && outcome.notChanged.length === 0) {
      basicInfo.status = data.status;
    }
    if (outcome.totes.length > 0 || outcome.notChanged.length > 0) {
      this.setState({statusChangeOutcome: outcome});
    }
  };

  acknowledgeTotes = () => {
    const {notChanged} = this.state.statusChangeOutcome;
    this.setState({statusChangeOutcome: {totes: [], notChanged}});
  };

  acknowledgeNotChanged = () => {
    this.setState({statusChangeOutcome: null});
  };

  confirmCartRemoval = async () => {
    const {data} = this.state.cartRemovalPrompt;
    this.setState({cartRemovalPrompt: null});
    this.statusChangeBusy = true;
    try {
      await this.sendStatusChange(data);
    } finally {
      this.statusChangeBusy = false;
    }
  };

  cancelCartRemoval = () => {
    this.setState({cartRemovalPrompt: null});
  };

  updateBasicInfo = async () => {
    this.setState({visible: true, loadingMessage: 'Saving Changes...'});
    let basicInfo = this.state?.order?.basicinfo;

    const executeUpdate = async () => {
      if (basicInfo) {
        basicInfo['app'] = 'app';
        let id = basicInfo.id;
        let data = basicInfo;
        await this.props.UpdateOrderInfo(id, data);
        updateOrderSuccessNew = true;
      }
    };

    if (!executeIfUpdationAllowed(this.getOrderStatus(), executeUpdate, this.alertBox)) {
      this.setState({visible: false});
      return false;
    }

    return true;
  };

  serializeOrder = order => serializeForComparison(order);

  snapshotSavedOrder = order => {
    this._savedOrderSnapshot = this.serializeOrder(order);
  };

  computeUnsavedChanges = () => {
    if (!this._savedOrderSnapshot) return false;
    const current = this.serializeOrder(this.state.order);
    if (!current) return false;
    return current !== this._savedOrderSnapshot;
  };


  handleUnsavedSave = async () => {
    this._closingAfterSave = false;
    this.setState({unsavedPromptVisible: false});
    await this.updateBasicInfo();
    this.snapshotSavedOrder(this.state.order);
    this.setState({hasUnsavedChanges: false}, () => {
      this.unsavedController.resume();
    });
  };

  handleUnsavedDiscard = () => {
    let restoredOrder = null;
    try {
      restoredOrder = this._savedOrderSnapshot
        ? JSON.parse(this._savedOrderSnapshot)
        : null;
    } catch (error) {
      restoredOrder = null;
    }

    const nextState = {hasUnsavedChanges: false, unsavedPromptVisible: false};
    if (restoredOrder) {
      nextState.order = restoredOrder;
    }

    this.setState(nextState, () => {
      this.unsavedController.resume();
    });
  };

  handleUnsavedStay = () => {
    this.unsavedController.cancel();
    this.setState({unsavedPromptVisible: false});
  };

  handleSaveAndClose = async () => {
    this._closingAfterSave = true;
    const saveStarted = await this.updateBasicInfo();
    if (!saveStarted) {
      this._closingAfterSave = false;
    }
  };

  handleCancel = () => {
    this.unsavedController.allowNextNavigation();
    this.goBackPage();
  };

  componentWillUnmount() {
    this.unsavedController.detach();
    this.backHandler.remove();
  }
  drawerClose = () => {
    this.props.route.params.closeDrawer();
  };

  textFileDownload = id => {
    this.props.activityTextFile(id);
  };
  emailSend = id => {
    this.props.emailCustomer(id);
  };
  recordExceptionMain = (id, data) => {
    this.props.recordException(id, data);
  };

  clearExceptionMain = id => {
    this.props.clearException(id);
  };
  goBackPage = () => {
    if (this.props.route.params.page == 'OrderSearch') {
      this.props.route.params.onComeBack();
    }
    this.props.navigation.goBack();
  };

  test = async () => {
    let num = await InterNetChecks();
    if (num !== true) {
      this.setState({popInternet: false});
    } else {
      this.setState({popInternet: true});
    }
  };

  handleOrderNavigation = (newIndex, orderId) => {
    if (!this.props.navigation.isFocused()) {
      return;
    }
    this.setState({
      currentOrderIndex: newIndex,
      visible: true,
      loadingMessage: 'Loading...'
    });

    this.apiCall(orderId);
  };

  // Get list of available tabs
  getAvailableTabs = () => {
    const {params} = this.props.route;
    const sslaelFromOrderSearch = params?.updateSetting?.print_ss_label;
    const checkPage = params?.page;
    const fromOrderSearchPage = params?.item?.print_ss_label;

    const tabs = [
      'itemActive',
      'notesActive',
      'informationActive',
      'activitiesActive',
      'multiBoxActive',
      'packingCamActive'
    ];

    if (checkPage == 'OrderSearch' ? fromOrderSearchPage : sslaelFromOrderSearch) {
      tabs.push('shippingLabelActive');
    }

    return tabs;
  };

  // Get currently active tab name
  getCurrentTab = () => {
    if (this.state.itemActive) return 'itemActive';
    if (this.state.notesActive) return 'notesActive';
    if (this.state.informationActive) return 'informationActive';
    if (this.state.activitiesActive) return 'activitiesActive';
    if (this.state.multiBoxActive) return 'multiBoxActive';
    if (this.state.packingCamActive) return 'packingCamActive';
    if (this.state.shippingLabelActive) return 'shippingLabelActive';
    return 'itemActive';
  };

  renderActivityIndicator = (message = 'Loading...') => (
    <View style={{flex: 1, justifyContent: 'center', backgroundColor: 'black'}}>
      <ActivityIndicator size="large" color="white" />
      <Text style={{textAlign: 'center', color: 'white', fontSize: 16}}>
        {message}
      </Text>
    </View>
  );
  renderTabsNavigation = () => {
    const {order, popInternet, ordersList, currentOrderIndex} = this.state;
    const {params} = this.props.route;
    const paramsData = params;
    let sslaelFromOrderSearch = paramsData?.updateSetting?.print_ss_label;
    let checkPage = paramsData?.page;
    let fromOrderSearchPage = paramsData?.item?.print_ss_label;
    let isSearchPage = paramsData?.page === 'OrderSearch' ? true : false;

    return (
      <View
        testID="orderDetailScrollContainer"
        style={{
          height:
            this.state.windowWidth >= 900
              ? 'calc(100vh - 64px)'
              : 'calc(100vh - 40px)',
          overflow: 'auto'
        }}>
      <UnsavedChangesBar
        visible={this.state.hasUnsavedChanges}
        saving={this.state.visible}
        onSave={this.handleUnsavedSave}
        onDiscard={this.handleUnsavedDiscard}
      />
      <UnsavedChangesPrompt
        visible={this.state.unsavedPromptVisible}
        saving={this.state.visible}
        onSave={this.handleUnsavedSave}
        onDiscard={this.handleUnsavedDiscard}
        onStay={this.handleUnsavedStay}
      />
      <LinearGradient
        colors={[
          '#000',
          '#000',
          '#5c778f',
          '#5c778f',
          '#253c57',
          '#253c57',
          '#000'
        ]}
        start={[-0.5, -1]}
        style={[
          CommonStyles.orderDetailStyle,
          {position: 'relative', height: 'auto', minHeight: '100%'}
        ]}>
        <View style={{flex: 1}}>
          {order && (
            <>
              {popInternet === false ? (
                <InerternetConnectionAlert />
              ) : null}
              <ArrowKeyNavigationHandler
                list={ordersList}
                currentIndex={currentOrderIndex}
                getItemId={(order) => order.order_info?.id}
                onNavigate={this.handleOrderNavigation}
              />
              <TabKeyNavigationHandler
                availableTabs={this.getAvailableTabs()}
                currentTab={this.getCurrentTab()}
                onTabChange={this.changeState}
              />
              <LinearGradient
                testID="orderDetailMenu"
                colors={['#2E3D46', '#587284']}
                style={{
                  flexDirection: 'row',
                  paddingTop: 5,
                  paddingLeft: '2%'
                }}>
                <ScrollView
                  horizontal={true}
                  showsHorizontalScrollIndicator={false}
                  showsVerticalScrollIndicator={false}
                  contentContainerStyle={{
                    flexGrow: 1
                  }}>
                  <TouchableOpacity
                    testID="showItems"
                    onPress={this.changeState.bind(this, 'itemActive')}
                    style={[
                      {
                        backgroundColor: this.state.itemActive ? '#000' : ''
                      },
                      styles.tabBtn
                    ]}>
                    <Text style={[styles.tabLabel]}>Order Items</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    testID="showNotes"
                    onPress={this.changeState.bind(this, 'notesActive')}
                    style={[
                      {
                        backgroundColor: this.state.notesActive ? '#000' : ''
                      },
                      styles.tabBtn
                    ]}>
                    <Text style={[styles.tabLabel]}>Notes</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    testID="showInformation"
                    onPress={this.changeState.bind(this, 'informationActive')}
                    style={[
                      {
                        backgroundColor: this.state.informationActive
                          ? '#000'
                          : ''
                      },
                      styles.tabBtn
                    ]}>
                    <Text style={[styles.tabLabel]}>Order Info</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    testID="showActivities"
                    onPress={this.changeState.bind(this, 'activitiesActive')}
                    style={[
                      {
                        backgroundColor: this.state.activitiesActive
                          ? '#000'
                          : ''
                      },
                      styles.tabBtn
                    ]}>
                    <Text style={[styles.tabLabel]}>Activity</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={this.changeState.bind(this, 'multiBoxActive')}
                    style={[
                      {
                        backgroundColor: this.state.multiBoxActive ? '#000' : ''
                      },
                      styles.tabBtn
                    ]}>
                    <Text style={[styles.tabLabel]}>Multi-Box Info</Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    testID="showPackingCam"
                    onPress={this.changeState.bind(this, 'packingCamActive')}
                    style={[
                      {
                        backgroundColor: this.state.packingCamActive
                          ? '#000'
                          : ''
                      },
                      styles.tabBtn
                    ]}>
                    <Text style={[styles.tabLabel]}>Packing Cam</Text>
                  </TouchableOpacity>
                  {(checkPage == 'OrderSearch'
                    ? fromOrderSearchPage
                    : sslaelFromOrderSearch) && (
                    <TouchableOpacity
                      dataSet={{componentName: 'shippingLabelActiveBtn'}}
                      onPress={this.changeState.bind(
                        this,
                        'shippingLabelActive'
                      )}
                      style={[
                        {
                          backgroundColor: this.state.shippingLabelActive
                            ? '#000'
                            : ''
                        },
                        styles.tabBtn
                      ]}>
                      <Text style={[styles.tabLabel]}>
                        Create Shipping Label
                      </Text>
                    </TouchableOpacity>
                  )}
                </ScrollView>
              </LinearGradient>

              {this.state.itemActive && popInternet && (
                <ItemsDetail
                  items={order}
                  token={this.state.token}
                  url={this.state.url}
                  redirect={this.redirect.bind(this)}
                  navigation={this.props.navigation}
                  updateQuantity={e => this.updateQuantity(e)}
                  addOrderItem={e => this.addOrderItem(e)}
                  updateOrderStatus={value => this.updateOrderStatus(value)}
                  removeOrderItem={ids => this.removeOrderItem(ids)}
                  goToProductDetail={id => this.goToProductDetail(id)}
                  removeIds={this.state.removeIds}
                  removeItems={() => this.removeItems()}
                  updateBasicInfo={() => this.handleSaveAndClose()}
                  back={() => this.handleCancel()}
                  userRole={paramsData?.userData}
                  show={this.state.productPermissionPopup}
                  isFromSearchPage={isSearchPage}
                  isFromProductPage={this.state.isFromProductPage}
                  resetFromProductPage={() =>
                    this.setState({isFromProductPage: false})
                  }
                />
              )}
              {this.state.notesActive && popInternet && (
                <NotesDetail
                  basicinfo={order.basicinfo}
                  navigation={this.props.navigation}
                  handleChange={(Name, Value) =>
                    this.handleBasicInfo(Name, Value)
                  }
                  updateOrderStatus={value => this.updateOrderStatus(value)}
                  updateBasicInfo={() => this.handleSaveAndClose()}
                  bothSettings={this.props.bothSettings}
                  userRole={paramsData?.userData}
                  back={() => this.handleCancel()}
                  show={this.state.productPermissionPopup}
                />
              )}
              {this.state.informationActive && popInternet && (
                <InformationDetail
                  basicinfo={order.basicinfo}
                  navigation={this.props.navigation}
                  handleChange={(Name, Value) =>
                    this.handleBasicInfo(Name, Value)
                  }
                  updateOrderStatus={value => this.updateOrderStatus(value)}
                  user={this.props?.route}
                  updateBasicInfo={() => this.handleSaveAndClose()}
                  back={() => this.handleCancel()}
                  bothSettings={this.props.bothSettings}
                  show={this.state.productPermissionPopup}
                />
              )}
              {this.state.activitiesActive && popInternet && (
                <ActivitiesExceptionDetail
                  basicinfo={order.basicinfo}
                  textFileDownload={id => this.textFileDownload(id)}
                  updateBasicInfo={() => this.handleSaveAndClose()}
                  back={() => this.handleCancel()}
                  activities={order.activities}
                  exception={order.exception}
                  navigation={this.props.navigation}
                  orderDetail={this.props.orderDetail}
                  userRole={paramsData?.userData}
                  recordExceptionMain={(id, data) =>
                    this.recordExceptionMain(id, data)
                  }
                  updateOrderStatus={value => this.updateOrderStatus(value)}
                  show={this.state.productPermissionPopup}
                  clearExceptionMain={id => this.clearExceptionMain(id)}
                  orderDetailFun={id => this.apiCall(id)}
                  orderException={this.props.orderException}
                  orderClearException={this.props.orderClearException}
                />
              )}
              {this.state.multiBoxActive && popInternet && (
                <MultiBoxDetail
                  navigation={this.props.navigation}
                  basicinfo={order.basicinfo}
                  updateBasicInfo={() => this.handleSaveAndClose()}
                  back={() => this.handleCancel()}
                  bothSettings={this.props.bothSettings}
                  handleChange={(Name, Value) =>
                    this.handleBasicInfo(Name, Value)
                  }
                  updateOrderStatus={value => this.updateOrderStatus(value)}
                  removeIds={this.state.removeIds}
                  removeOrderItem={ids => this.removeOrderItem(ids)}
                  removeItems={() => this.removeItems()}
                  updateQuantity={e => this.updateQuantity(e)}
                  orderDetailFun={id => this.apiCall(id)}
                  show={this.state.productPermissionPopup}
                  orderDetail={this.props.orderDetail}
                  userRole={paramsData?.userData}
                  removeBox={this.removeBox}
                  addBox={this.addBox}
                  addItemBox={this.addItemBox}
                  printSlip={this.printSlip}
                />
              )}
              {this.state.packingCamActive && popInternet && (
                <PackingCamDetail
                  {...this.props}
                  navigation={this.props.navigation}
                  order={this.props.orderDetail}
                  isRemovingImage={this.props.isRemovingImage}
                  updateBasicInfo={isEmail => {
                    isfromEmailPopup = isEmail;
                    if (isEmail) {
                      this.updateBasicInfo();
                    } else {
                      this.handleSaveAndClose();
                    }
                  }}
                  updateOrderStatus={value => this.updateOrderStatus(value)}
                  back={() => this.handleCancel()}
                  userRole={paramsData?.userData}
                  show={this.state.productPermissionPopup}
                  emailSend={id => {
                    this.emailSend(id);
                  }}
                />
              )}
              {this.state.shippingLabelActive && popInternet && (
                <ShippingLabel
                  navigation={this.props.navigation}
                  basicinfo={order.basicinfo}
                  userRole={this.props.route.params.userData}
                  updateOrderStatus={value => this.updateOrderStatus(value)}
                  back={() => this.handleCancel()}
                  bothSettings={this.props.bothSettings}
                />
              )}
            </>
          )}
        </View>
      </LinearGradient>
      </View>
    );
  };
  render() {
    return (
      <PopupAlert>
        {({ alertBox, closeAlert }) => {
          this.alertBox = alertBox;
          this.closeAlert = closeAlert;
          return (
            <View style={{flex: 1}} onStartShouldSetResponder={this.drawerClose}>
              {this.state.visible
                ? this.renderActivityIndicator(this.state.loadingMessage)
                : this.renderTabsNavigation()}
              <StatusChangeOutcomeModal
                outcome={this.state.statusChangeOutcome}
                onTotesAcknowledged={this.acknowledgeTotes}
                onNotChangedAcknowledged={this.acknowledgeNotChanged}
              />
              {this.state.cartRemovalPrompt && (
                <CartRemovalConfirmModal
                  visible
                  message={this.state.cartRemovalPrompt.message}
                  onConfirm={this.confirmCartRemoval}
                  onCancel={this.cancelCartRemoval}
                />
              )}
            </View>
          );
        }}
      </PopupAlert>
    );
  }
}

const mapStateToProps = state => {
  return {
    orderDetail: state.order.order,
    saveData: state.updateAsync.retriveData,
    removeOrderItems: state.order.removeOrderItems,
    updateOrderSuccess: state.order.updateOrder,
    orderException: state.order.exception,
    orderClearException: state.order.clearException,
    bothSettings: state.user.bothSettings,
    isRemovingImage: state.order.isRemovingImage
  };
};

const mapDispatchToProps = {
  GetOrderDetail,
  GetItem,
  UpdateOrderQuantity,
  activityTextFile,
  emailCustomer,
  RemoveOrderItems,
  UpdateOrderInfo,
  UpdateOrderStatus,
  CartedOrdersPreview,
  SubmitLog,
  SetItem,
  OrderBackButtonClick,
  GetBothSettings,
  recordException,
  clearException,
  RemoveBox,
  AddBox,
  AddItemBox,
  PrintSlip
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetail);
